import {Bars4Icon, Squares2X2Icon} from "@heroicons/react/24/outline";
import {CarViewEnum} from "../../../Enums/CarViewEnum";
import {useState} from "react";

export const TabButton = ({identifier, label, number, className, active, onClick}) => {
    const [selectedView, setSelectedView] = useState(CarViewEnum.list);

    const handleViewClick = (e, view) => {
        e.stopPropagation();

        if (view !== null) {
            setSelectedView(view);
        } else {
            view = selectedView;
        }
        onClick?.({identifier, view});
    };

    return (
        <div>
            <div onClick={(e) => handleViewClick(e, null)} className={`relative flex cursor-pointer items-center gap-2 ${active ? 'bg-gray-800 text-gray-300' : 'bg-gray-100 text-gray-400 hover:bg-gray-800'} px-3 py-2 rounded-md transition-colors duration-200 ${className}`}>
                <div className="border-r border-r-gray-300 pr-2">{number}</div>
                <div>
                    {label}
                </div>
                <div className="pl-2 flex items-center">
                    <div onClick={(e) => handleViewClick(e, CarViewEnum.list)} className={`border border-gray-300 rounded p-1 flex justify-center mr-2 ${CarViewEnum.list === selectedView && active ? 'bg-gray-100' : ''} hover:bg-gray-200 hover:text-black transition-colors duration-200`}>
                        <Bars4Icon className="w-5 h-5"/>
                    </div>
                    <div onClick={(e) => handleViewClick(e, CarViewEnum.cards)} className={`border border-gray-300 rounded p-1 flex justify-center ${CarViewEnum.cards === selectedView && active ? 'bg-gray-100' : ''} hover:bg-gray-200 hover:text-black transition-colors duration-200`}>
                        <Squares2X2Icon className="w-5 h-5"/>
                    </div>
                </div>
            </div>
        </div>
    );
}